// src/store/thunk/wishlistThunk.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const joinWishlist = createAsyncThunk(
    'wishlist/join',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('wishlist/join', payload);
            // Backend returns HTTP 200 with status: 0 for business-level errors
            if (data?.status === 0) {
                return rejectWithValue(data.message || 'Failed to join wishlist. Please try again.');
            }
            return data;
        } catch (error) {
            const msg =
                error.response?.data?.message ||
                error.response?.data?.detail ||
                'Failed to join wishlist. Please try again.';
            return rejectWithValue(msg);
        }
    },
);

// Admin: paginated wishlist list
export const fetchWishlistList = createAsyncThunk(
    'wishlist/fetchList',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('wishlist/list', {
                params: payload,
            });
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch wishlist list',
            );
        }
    },
);

